import styled from 'styled-components';

export const UserCardWrapper = styled.div`
    display: flex;
    min-width: 360px;
    padding: 12px 0 8px 0;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    background: #fff;
`;

export const UserCardContainer = styled.div`
    display: flex;
    padding: 0 20px;
    align-items: center;
    gap: 12px;
    align-self: stretch;
`;

export const VehicleCardDetailsWrapper = styled.div<{
    isUpcomingBooking?: boolean;
}>`
    display: flex;
    padding: 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    flex: 1 0 0;
    border-radius: 12px;
    border: 1px solid #e8e8e8;
    background: #f5f5f5;
    ${({ isUpcomingBooking }) =>
        isUpcomingBooking
            ? `
        background: #f5f5f5;
    `
            : `
        background: #fff;
    `}
`;

export const UserWelcomeHeadingWrapper = styled.div`
    display: flex;
    padding: 0 20px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
`;

export const ContinueText = styled.div`
    flex: 1 0 0;
    color: #121212;
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
`;

export const ButtonWrapper = styled.div`
    display: flex;
    padding: 12px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    border-radius: 12px;
    background: #121212;
    backdrop-filter: blur(25px);
`;

export const ButtonText = styled.div`
    color: #fff;
    font-family: 'Euclid Circular B';
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
`;

export const VehicleDetailsWrapper = styled.div`
    display: flex;
    width: 296px;
    align-items: center;
    justify-content: center;
    gap: 12px;
`;

export const VehicleImageContainer = styled.div`
    display: flex;
    padding: 0 6px 3px 0;
    align-items: center;
    aspect-ratio: 25/14;
`;

export const VehicleDetailsContainer = styled.div`
    display: flex;
    width: 176px;
    height: 40px;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 4px;
    flex-shrink: 0;
`;

export const VehicleDetailsTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    flex: 1;
`;

export const VehicleName = styled.div`
    color: #121212;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
`;

export const VehicleNumber = styled.div`
    color: #4b4b4b;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
`;

export const ArrowIconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const AppointmentDataTimeWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 24px;
    align-self: stretch;
`;

export const AppointmentDataTimeContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
`;

export const CalenderIconContainer = styled.div`
    display: flex;
    width: 20px;
    height: 20px;
    padding: 2.5px 2.5px 2.085px 2.5px;
    justify-content: center;
    align-items: center;
    aspect-ratio: 1/1;
`;

export const TimeIconContainer = styled.div`
    display: flex;
    width: 20px;
    height: 20px;
    padding: 2.5px 2.085px 2.5px 2.5px;
    justify-content: center;
    align-items: center;
    aspect-ratio: 1/1;
`;

export const SplitIconContainer = styled.div`
    width: 0;
    height: 16px;
    stroke-width: 1px;
    stroke: #e8e8e8;
`;

export const AppointmentDateTimeText = styled.div`
    color: #121212;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
`;

export const UpcomingBookingContentWrapper = styled.div`
    display: flex;
    padding: 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    flex: 1 0 0;
    border-radius: 12px;
    border: 1px solid #e8e8e8;
    background: #fff;
`;
